module.exports = __webpack_public_path__ + "f60af72207aa4cce7eb6934b7af46cf0.ttf";